module.exports = __webpack_public_path__ + "static/media/vwlyr.f9f64d2e.webp";